














import Vue from 'vue';
import {Component, Emit, Prop} from "vue-property-decorator";
import AsiCardDetail from "../common/AsiCardDetail.vue";
import {Icon} from "@/helpers/icons";
import {
	createAddressLinesArray,
	createAddressPersonLine,
	createEmailArray,
	createPhoneString
} from "@/helpers/functions_td";
import User from "@/models/user/User";
import AsiCardDetailEntry from "@/components/common/AsiCardDetailEntry.vue";
import UserUpdateDialogContactAddress from "@/components/user/UserUpdateDialogContactAddress.vue";
import {Permissions} from "@/helpers/constants";

@Component({
	components: {UserUpdateDialogContactAddress, AsiCardDetailEntry, AsiCardDetail}
})
export default class UserCardContactAddress extends Vue {

	@Prop({type: Object, default: null})
	public user!: User | null;

	private icons = Icon;
	private updateDialogOpen: boolean = false;

	private get personLines(): string[] | null {
		return createAddressPersonLine(this.user?.address ?? null);
	}

	private get addressLines(): string[] | null {
		return createAddressLinesArray(this.user?.address ?? null);
	}

	private get emailEntries(): string[] | null {
		return createEmailArray(this.user?.address.emails ?? null);
	}

	private get phoneString(): string | null {
		return createPhoneString(this.user?.address.phone ?? null);
	}

	private get isMasterData(): boolean {
		return this.$store.getters['user/hasPermission'](Permissions.rightMasterData);
	}

	@Emit('userChanged')
	public userChanged(event: Event): Event {
		this.updateDialogOpen = false;
		return event;
	}

}
